import React from 'react';
import { Headphones, BookOpen, Radio, Tag } from 'lucide-react';

// Voice-First profile menu: 🎙 Racconti Audio | 📖 Racconti Testo | 🔴 Live | 🏷 Categorie.
const TABS = [
  { key: 'audio', label: 'Racconti Audio', Icon: Headphones },
  { key: 'text', label: 'Racconti Testo', Icon: BookOpen },
  { key: 'live', label: 'Live', Icon: Radio },
  { key: 'categories', label: 'Categorie', Icon: Tag },
];

export const VoiceTabsBar = ({ active, onChange, testPrefix = 'voice-tab' }) => (
  <nav className="-mx-1 flex gap-1.5 overflow-x-auto px-1 pb-1" data-testid={`${testPrefix}-bar`}>
    {TABS.map(({ key, label, Icon }) => (
      <button
        key={key}
        type="button"
        onClick={() => onChange(key)}
        data-testid={`${testPrefix}-${key}`}
        className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-2 text-xs font-bold uppercase tracking-wide transition-colors ${
          active === key
            ? 'border-amber-500 bg-amber-500/15 gold-text'
            : 'border-border text-muted-foreground hover:bg-secondary'
        }`}
      >
        <Icon className={`h-3.5 w-3.5 ${key === 'live' ? 'text-red-500' : ''}`} /> {label}
      </button>
    ))}
  </nav>
);

export default VoiceTabsBar;
